module.exports = __webpack_public_path__ + "static/media/login-block-img.b7412a13.svg";